var e;!function(e){e.ChangePassword="amplify-accountsettings-changepassword",e.DeleteUser="amplify-accountsettings-deleteuser"}(e||(e={}));export{e as ComponentClassName};
